module.exports = __webpack_public_path__ + "static/img/ys-1-400.fdcd27e.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images/ys-1-400.webp
// module id = Pns9
// module chunks = 11